import React, { useEffect, useState, useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { GlobalContext } from '../../Contexts/GlobalContext';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import useGuiTranslations from './useGuiTranslations';
import { capitalizeFirstLetter } from '../../Util/StringFunctions';


export default function CountrySelector(props) {
    const globalContext = useContext(GlobalContext);
    const [translateGui] = useGuiTranslations();
    const classes = useStyles();
    const countries = [
        { code: 'GB', name: 'United Kingdom' },
        { code: 'SE', name: 'Sweden' },
        { code: 'CH', name: 'Switzerland' },
        { code: 'DE', name: 'Germany' },
        { code: 'FR', name: 'France' },
        { code: 'TR', name: 'Turkey' },
    ];


    return (
        <FormControl className={classes.formControl}>
            <InputLabel id="language-label">Country</InputLabel>
            {
                <Select
                    labelId="language-label"
                    id="language-select"
                    value={props.country}
                    onChange={(e) => props.setCountry(e.target.value)}
                >
                    {
                        countries.map(
                            (country, index) =>
                                <MenuItem key={country.code} value={country.code}>{country.name}</MenuItem>
                        )
                    }

                </Select>
            }
        </FormControl>
    )
}

const useStyles = makeStyles({
    root: {
    }
});